import { ClockCircleOutlined, EnvironmentOutlined, SettingOutlined, TeamOutlined } from "@ant-design/icons/lib/icons";
import { Button, Card, Col, Row, Skeleton, Typography } from "antd";
import axios from "axios";
import CompanyLogo from "components/CompanyLogo/CompanyLogo";
import dayjs from "dayjs";
import { Company } from "interfaces/companies";
import { Event, Location } from "interfaces/events";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";

const { Title } = Typography;

interface Props {
  event: Event;
  responsibility_type: number;
  date: string;
  company: Company;
}

const ResponsibilityBox: React.FC<Props> = ({ event, responsibility_type, date, company }) => {
  const [location, setLocation] = useState<string>();

  useEffect(() => {
    axios.get<Location>(`/events/locations/${event.location}/`).then(response => {
      setLocation(response.data.name);
    });
  }, [event]);

  const history = useHistory();

  const openEvent = () => {
    return history.push(`/admin/events/${event.id}/`);
  };

  const getResponsibilityType = () => {
    if (responsibility_type === 1) return "HA";
    if (responsibility_type === 2) return "mentor";
    if (responsibility_type === 3) return "MP";
  };

  const getTitle = () => {
    const type = getResponsibilityType();
    const now = new Date();
    const eventStart = new Date(date);

    now.setHours(0, 0, 0, 0); // set both dates to 0 hours so we find days difference, without hours disturbing
    eventStart.setHours(0, 0, 0, 0);

    const difference = eventStart.getTime() - now.getTime();
    const daysDifference = Math.ceil(difference / (1000 * 3600 * 24));
    if (daysDifference > 1) return `Du er ${type} for ${company?.name} om ${daysDifference} dager`;
    if (daysDifference === 1) return `Du er ${type} for ${company?.name} i morgen`;
    if (daysDifference === -1) return `Du var ${type} for ${company?.name} i går`;
    if (daysDifference < -1) return `Du var ${type} for ${company?.name} for ${-daysDifference} dager siden`;
    return `Du er ${type} for ${company?.name} i dag`;
  };

  return (
    <>
      <Card
        hoverable
        onClick={openEvent}
        style={{ marginBottom: "20px" }}
        bodyStyle={{ padding: "0.5em", paddingLeft: "0.8em" }}
      >
        <Row>
          <Col md={4} sm={6} xs={6}>
            {company ? <CompanyLogo size="100%" companyId={company.id} src={company.logo} /> : <Skeleton.Image />}
          </Col>
          <Col
            md={12}
            sm={16}
            xs={18}
            style={{ paddingLeft: "1em", lineHeight: "100%", paddingTop: "0.5em", paddingBottom: "0.5em" }}
          >
            <Row>
              <Title level={4}>{getTitle()}</Title>
            </Row>
            <Row>
              <Col span={12}>
                <EnvironmentOutlined style={{ marginRight: "0.4em" }} />
                {location ?? "Ikke bestemt"}
              </Col>
              <Col span={12}>
                <ClockCircleOutlined style={{ marginRight: "0.4em" }} />
                kl. {dayjs(event.start).format("HH:mm")}
              </Col>
            </Row>
          </Col>
          <Col md={8} sm={24} xs={24} style={{ textAlign: "center", paddingTop: "7px" }}>
            <Link to={`/admin/events/${event.id}/`}>
              <Button type="primary">Åpne</Button>
            </Link>
            <Link to={`/admin/events/${event.id}/edit`}>
              <Button type="primary" title="Rediger arrangementet" style={{ margin: "0 5px" }}>
                <SettingOutlined />
              </Button>
            </Link>
            {new Date(event.start) > new Date() ? (
              <Link to={`/admin/events/${event.id}/seats`}>
                <Button type="primary">
                  <TeamOutlined />
                </Button>
              </Link>
            ) : (
              <Button type="primary" danger>
                NOSHOW {/* // TODO functionality */}
              </Button>
            )}
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default ResponsibilityBox;
